var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              attrs: {
                xs: "6",
                sm: "4",
                md: "4",
                lg: "2",
                id: "filter-controls",
              },
            },
            [
              _c(
                "div",
                [
                  _c("h3", { staticStyle: { display: "inline" } }, [
                    _vm._v(_vm._s(this.$t("message.filters"))),
                  ]),
                  _c(
                    "b-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { size: "md", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.clearAllFilters()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(this.$t("message.clear_all"))
                      ),
                    ]
                  ),
                  _c("br"),
                  _c("br"),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "showInactive-form-group",
                        label: this.$t("message.projects"),
                      },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            id: "showInactive-form-checkbox",
                            value: "true",
                            "unchecked-value": "false",
                          },
                          model: {
                            value: _vm.showInactive,
                            callback: function ($$v) {
                              _vm.showInactive = $$v
                            },
                            expression: "showInactive",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                this.$t("message.show_inactive_projects")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "showSuppressed-form-group",
                        label: this.$t("message.analysis_status"),
                      },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            id: "showSuppressed-form-checkbox",
                            value: "true",
                            "unchecked-value": "false",
                          },
                          model: {
                            value: _vm.showSuppressed,
                            callback: function ($$v) {
                              _vm.showSuppressed = $$v
                            },
                            expression: "showSuppressed",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                this.$t("message.show_suppressed_findings")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "severity-form-group",
                        label: this.$t("message.severity"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "severity-form-checkbox-group",
                          options: _vm.severityOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.severitySelected,
                          callback: function ($$v) {
                            _vm.severitySelected = $$v
                          },
                          expression: "severitySelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "analysis-status-form-group",
                        label: this.$t("message.analysis_state"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "analysis-status-form-checkbox-group",
                          options: _vm.analysisStatusOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.analysisStatusSelected,
                          callback: function ($$v) {
                            _vm.analysisStatusSelected = $$v
                          },
                          expression: "analysisStatusSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "vendor-response-form-group",
                        label: this.$t("message.vendor_response"),
                      },
                    },
                    [
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "vendor-response-form-checkbox-group",
                          options: _vm.vendorResponseOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.vendorResponseSelected,
                          callback: function ($$v) {
                            _vm.vendorResponseSelected = $$v
                          },
                          expression: "vendorResponseSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "publish-date-form-group",
                        label: this.$t("message.published"),
                      },
                    },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          id: "publish-date-datepicker-from",
                          max: _vm.publishDateTo,
                          placeholder: this.$t("message.from"),
                        },
                        model: {
                          value: _vm.publishDateFrom,
                          callback: function ($$v) {
                            _vm.publishDateFrom = $$v
                          },
                          expression: "publishDateFrom",
                        },
                      }),
                      _c("b-datepicker", {
                        attrs: {
                          id: "publish-date-datepicker-to",
                          min: _vm.publishDateFrom,
                          placeholder: this.$t("message.to"),
                        },
                        model: {
                          value: _vm.publishDateTo,
                          callback: function ($$v) {
                            _vm.publishDateTo = $$v
                          },
                          expression: "publishDateTo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "attributed-on-date-form-group",
                        label: this.$t("message.attributed_on"),
                      },
                    },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          id: "attributed-on-datepicker-from",
                          max: _vm.attributedOnDateTo,
                          placeholder: this.$t("message.from"),
                        },
                        model: {
                          value: _vm.attributedOnDateFrom,
                          callback: function ($$v) {
                            _vm.attributedOnDateFrom = $$v
                          },
                          expression: "attributedOnDateFrom",
                        },
                      }),
                      _c("b-datepicker", {
                        attrs: {
                          id: "attributed-on-datepicker-to",
                          min: _vm.attributedOnDateFrom,
                          placeholder: this.$t("message.to"),
                        },
                        model: {
                          value: _vm.attributedOnDateTo,
                          callback: function ($$v) {
                            _vm.attributedOnDateTo = $$v
                          },
                          expression: "attributedOnDateTo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "text-search-form-group",
                        label: this.$t("message.text_search"),
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "text-search-form-input",
                          debounce: "750",
                          placeholder: this.$t("message.search"),
                        },
                        model: {
                          value: _vm.textSearchInput,
                          callback: function ($$v) {
                            _vm.textSearchInput = $$v
                          },
                          expression: "textSearchInput",
                        },
                      }),
                      _vm._v("\n          Search in:\n          "),
                      _c("b-form-checkbox-group", {
                        attrs: {
                          id: "text-search-form-checkbox-group",
                          options: _vm.textSearchOptions,
                          stacked: "",
                        },
                        model: {
                          value: _vm.textSearchSelected,
                          callback: function ($$v) {
                            _vm.textSearchSelected = $$v
                          },
                          expression: "textSearchSelected",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "cvssv2-form-group",
                        label: this.$t("message.cvss_v2"),
                      },
                    },
                    [
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cvssv2-from-form-input",
                                  type: "number",
                                  min: "0",
                                  max: _vm.cvssv2UpperLimit(),
                                  step: "0.1",
                                  debounce: "750",
                                  state: _vm.cvssv2FromState(),
                                  placeholder: this.$t("message.from"),
                                },
                                model: {
                                  value: _vm.cvssv2From,
                                  callback: function ($$v) {
                                    _vm.cvssv2From = $$v
                                  },
                                  expression: "cvssv2From",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cvssv2-to-form-input",
                                  type: "number",
                                  min: _vm.cvssv2LowerLimit(),
                                  max: "10",
                                  step: "0.1",
                                  debounce: "750",
                                  state: _vm.cvssv2ToState(),
                                  placeholder: this.$t("message.to"),
                                },
                                model: {
                                  value: _vm.cvssv2To,
                                  callback: function ($$v) {
                                    _vm.cvssv2To = $$v
                                  },
                                  expression: "cvssv2To",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "cvssv3-form-group",
                        label: this.$t("message.cvss_v3"),
                      },
                    },
                    [
                      _c(
                        "b-form-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cvssv3-from-form-input",
                                  type: "number",
                                  min: "0",
                                  max: _vm.cvssv3UpperLimit(),
                                  step: "0.1",
                                  debounce: "750",
                                  state: _vm.cvssv3FromState(),
                                  placeholder: this.$t("message.from"),
                                },
                                model: {
                                  value: _vm.cvssv3From,
                                  callback: function ($$v) {
                                    _vm.cvssv3From = $$v
                                  },
                                  expression: "cvssv3From",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "cvssv3-to-form-input",
                                  type: "number",
                                  min: _vm.cvssv3LowerLimit(),
                                  max: "10",
                                  step: "0.1",
                                  debounce: "750",
                                  state: _vm.cvssv3ToState(),
                                  placeholder: this.$t("message.to"),
                                },
                                model: {
                                  value: _vm.cvssv3To,
                                  callback: function ($$v) {
                                    _vm.cvssv3To = $$v
                                  },
                                  expression: "cvssv3To",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-col",
            { attrs: { xs: "6", sm: "8", md: "8", lg: "10" } },
            [
              _c("bootstrap-table", {
                ref: "table",
                attrs: {
                  columns: _vm.columns,
                  data: _vm.data,
                  options: _vm.options,
                },
                on: { "on-load-success": _vm.onLoadSuccess },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }